import React from 'react'

import * as S from './divider.styled'
import { DividerProps } from './divider.types'

export const Divider = ({
  orientation = 'horizontal',
  variant = 'fullWidth',
  flexItem = false,
  light = false,
  color,
  textAlign = 'center',
  children,
  ...rest
}: DividerProps) => {
  return (
    <S.Root
      role="separator"
      aria-orientation={orientation}
      $orientation={orientation}
      $variant={variant}
      $flexItem={flexItem}
      $light={light}
      $color={color}
      $hasChildren={!!children}
      $textAlign={textAlign}
      {...rest}
    >
      {children}
    </S.Root>
  )
}
